export default function BuildingBookAssetDocuments()
{
	
	const button =
	{
	    height: "40px",

	    padding: "0px 20px",

	    border: "0px",

	    borderRadius: "20px",

	    background:
	        "linear-gradient(180deg,#5a9bd6 0%,#417fb7 100%)",

	    color: "#fff",

	    fontWeight: "600",

	    cursor: "pointer",

	    marginBottom: "20px"
	};
	const documentList =
		{
		    marginTop: "20px",

		    background: "#fff",

		    border:
		        "1px solid #e5e7eb",

		    borderRadius: "10px",

		    overflow: "hidden"
		};

		
    return (

        <div>

            <button style={button}>
                Upload Document
            </button>

            <div style={documentList}>

                <DocumentRow
                    name="Installation Manual.pdf"
                />

                <DocumentRow
                    name="Warranty.pdf"
                />

                <DocumentRow
                    name="Commissioning Report.pdf"
                />

            </div>

        </div>

    );
}


function DocumentRow(
{
    name
})
{
	
	const documentRow =
			{
			    display: "flex",

			    alignItems: "center",

			    padding: "14px 16px",

			    borderBottom:
			        "1px solid #f1f3f5",

			    cursor: "pointer",

			    transition:
			        "background 0.2s ease"
			};
	
    return (

        <div
            style={documentRow}
        >

            <div
                style={{
                    fontSize: "24px",
                    marginRight: "12px"
                }}
            >
                📄
            </div>

            <div
                style={{
                    flex: 1
                }}
            >
                <div
                    style={{
                        fontWeight: "600"
                    }}
                >
                    {name}
                </div>

                <div
                    style={{
                        fontSize: "11px",
                        color: "#888"
                    }}
                >
                    Uploaded 12-Jun-2026
                </div>
            </div>

        </div>

    );
}